import type { HelpFile } from '../../types/help'
import { ProfileTestIds } from '../../../testids/ProfileTestIds'

export const profileHelp: HelpFile = {
  docPage: '/docs/getting-started/profile',
  texts: {
    [ProfileTestIds.sectionBasicInfo]:
      'Profildaten des angemeldeten Kontos — Name, E-Mail und Authentifizierungsquelle.',
    [ProfileTestIds.sectionIamIdentity]:
      'IAM-Identität, die mit diesem Konto verknüpft ist — über den Link lässt sich die vollständige Identitäts-Detailseite öffnen.',
    [ProfileTestIds.cardTitleSessionInfo]:
      'Aktuelle Anmeldesitzung — OAuth2-Aussteller und Ablaufzeit.',
    [ProfileTestIds.cardTitleRolesPermissions]:
      'Dem angemeldeten Konto zugewiesene Rollen und Berechtigungen — steuern den Zugriff in der gesamten Anwendung.',
    [ProfileTestIds.linkIdentityDetails]: null,
    [ProfileTestIds.btnLogout]: null,
    [ProfileTestIds.btnTogglePermissions]:
      'Vollständige Liste der aus den Rollen abgeleiteten Berechtigungen ein- oder ausblenden.',
    [ProfileTestIds.inputFilterPermissions]:
      'Berechtigungen nach Ressource oder Aktion filtern.',
    [ProfileTestIds.colResource]:
      'Ressource (Controller oder Domänenobjekt), für die die Berechtigung gilt.',
  },
}
